import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Input from "../../../../components/elements/form/input";
import Teaxtarea from "../../../../components/elements/form/textarea";
import SelectBox from "../../../../components/elements/form/selectBox";
import { DropdownOptionType, Option } from "../../../../_config/types";
import Datepicker from "../../../../components/elements/form/datepicker";
import Button from "../../../../components/elements/button";
import mapImg from "../../../../images/map-left.jpg";
import qrImg from "../../../../images/facility-qr.jpg";
import partsImg from "../../../../images/parts-pic.jpg";
import Icon from "../../../../components/icons";
import { useFacilitiesApi } from "../../../../store/api/hooks/facilitiesApiHook";
import toast from "react-hot-toast";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import { useFacilityManagersSelector } from "../../../../store/selectors/masterSelector";
import { useCommonApi } from "../../../../store/api/hooks/commonApiHook";
import { useCycleCountApi } from "../../../../store/api/hooks/cycleCountApiHook";
import { getPermissionInfo, getSelectedOption } from "../../../../_common/functions";
import Label from "../../../../components/elements/form/fromLabel";
import moment from "moment";
import { DATE_FORMAT } from "../../../../_common/constant";
import Currency from "../../../../components/currency";
import { Dropdown, Menu } from "../../../../components/Dropdown";
import { useUserSelector } from "../../../../store/selectors/userSelector";
import { useLocation } from "react-router-dom";

interface Props {
	_ref?: any;
	viewData?: any;
	onCreate?: () => void;
	onCancel?: () => void;
	ExportXls?: (payload: any) => void;
	ExportPdf?: (payload: any) => void;
}
type FormValues = {
	cycleCountNotes: string;
	operatorID: any;
	assetType: string;
	purchaseDate: Date | null;
	facilityID: any;
	subFacilityID: any;
	isDraft: boolean;
};

const ViewCycleCount: React.FC<Props> = ({
	_ref,
	viewData,
	onCreate = () => { },
	onCancel = () => { },
	ExportXls = (payload: any) => { },
	ExportPdf = (payload: any) => { },
}) => {
	const [facilityoption, setFacilityoption] = useState<any>(null);
	const [subfacilitylist, setsubfacilityoption] = useState<any>([]);
	const [cycleCountCode, setCycleCountCode] = useState<any>(null);
	const [partstatus, setPartStatus] = useState<boolean>(false);
	const [scanCode, setScanCode] = useState<string>('');
	const [parts, setParts] = useState<any>([]);
	const facilityApi: any = useFacilitiesApi();
	const commonApi: any = useCommonApi();
	const spearPartsAPI = useSpearPartsApi();
	const cycleCountAPI = useCycleCountApi();
	const loggedinuser: any = useUserSelector();
	const location = useLocation();

	const {
		control,
		register,
		handleSubmit,
		setValue,
		reset,
		trigger,
		formState: { errors },
		watch,
	} = useForm<FormValues>({
		defaultValues: {
			isDraft: false,
			cycleCountNotes: ""
		}
	});
	const users = useFacilityManagersSelector();
	const facilityWatch = watch("facilityID");
	console.log("view data", viewData);

	const getfacilitylist = () => {
		const payload = {};
		facilityApi.getFacilityList(
			payload,
			(resp: any) => {
				let facilitylist: any = [];
				resp.facilityList.map((facilist: any) => {
					facilitylist.push({
						label: facilist.facilityName,
						value: facilist.facilityID,
						data: facilist,
					});
				});
				setFacilityoption(facilitylist);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	const getsubfacilityList = (_facilityID: any) => {
		const payload = { facilityID: _facilityID };
		facilityApi.getSubFacilityList(
			payload,
			(resp: any) => {
				let subfacilityoption: any = resp?.subFacilityList?.map(
					(countylist: any) => {
						return {
							label: `${countylist.subFacilityTypeName} - ${countylist.no}`,
							value: countylist.subFacilityID,
						};
					}
				);
				setsubfacilityoption(subfacilityoption);

				if (viewData) {
					setValue("subFacilityID", getSelectedOption(viewData?.subFacilityID, subfacilityoption));
				}

			},
			(error: any) => {
				console.log("error =>", error);
				setsubfacilityoption([]);
				toast.error(error);
			}
		);
	};

	const getCycleCountCode = () => {
		const payload = {};
		cycleCountAPI.GetID(
			payload,
			(resp: any) => {

				setCycleCountCode(resp.code);
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (users == null) {
			commonApi.GetUserList(
				{
					pageNo: 1,
					pageSize: 1000,
				},
				(resp: any) => { },
				(error: any) => { }
			);
		}
	}, [users]);

	useEffect(() => {
		if (facilityWatch) {
			setValue("subFacilityID", null);
			getsubfacilityList(facilityWatch.value);
		}
	}, [facilityWatch]);

	const formReset = () => {
		reset({
			cycleCountNotes: '',
			operatorID: '',
			assetType: '',
			purchaseDate: null,
			facilityID: '',
			subFacilityID: ''

		});
		setParts([])
		setPartStatus(false)
	};

	useEffect(() => {
		if (_ref?.current) {
			_ref.current.reset = formReset;
		}
	}, [_ref]);

	const onSubmit: SubmitHandler<FormValues> = (data) => {
		let cyclecnt: any = [];
		parts.map((part: any) => {
			cyclecnt.push({
				"partsID": part.partDetails.partsID,
				"systemQuantity": part.currentStock,
				"countedQuantity": part.qty,
				"partsCostRate": part.partDetails.costPerUnit,
				"unitID": part.partDetails.unitID,
				"isDraft": false
			})

		})

		let payload = {
			"inventoryCycleCountCode": cycleCountCode,
			"operatorID": data.operatorID?.value,
			"facilityID": data.facilityID?.value,
			"subFacilityID": data.subFacilityID?.value,
			"countingDate": data?.purchaseDate,
			"cycleCountNotes": data.cycleCountNotes,
			"isDraft": !data.isDraft,
			"cycleCountDetails": cyclecnt
		}
		//console.log("fsfsfsfsfsff1",payload)
		cycleCountAPI.Save(
			payload,
			(resp: any) => {
				onCreate();
				formReset();
				getCycleCountCode();
				toast.success("Cycle count Saved Successfully")
			},
			(error: any) => {
				console.log("error =>", error);
				toast.error(error);
			}
		);
	};

	useEffect(() => {
		if (facilityoption) {
			console.log('facilityoption', viewData);
			if (!viewData) {
				getCycleCountCode();
			} else {
				setPartStatus(true);
				setCycleCountCode(viewData?.inventoryCycleCountCode);
				setValue("facilityID", getSelectedOption(viewData?.facilityID, facilityoption ? facilityoption : []));
				setValue("purchaseDate", viewData?.addedDate);
				setValue("operatorID", getSelectedOption(viewData?.operatorID, users ? users : []));
				setValue("cycleCountNotes", viewData?.cycleCountNotes);
				cycleCountAPI.GetByID({ InventoryCycleCountID: viewData.inventoryCycleCountID }, (resp: any) => {
					setParts(resp?.cycleCountList?.map((part: any) => {
						const netChange = Number(part?.countedQuantity ?? 0) - Number(part?.systemQuantity ?? 0);
						const avgCost = Number(part?.avgUnitCost ?? 0);
						return {
							label: part?.partName + ` (${part?.partsCode})`,
							value: part?.partsID,
							partDetails: { sparePartsName: part?.partName, partsCode: part?.partsCode, costPerUnit: part?.partsCostRate, unitID: part?.unitID },
							currentStock: part?.systemQuantity,
							qty: part?.countedQuantity,
							partsCostRate: part?.partsCostRate,
							avgUnitCost: avgCost,
							signedAdjustmentCost: netChange * avgCost,
						}
					}))

					console.log("return resp--------", resp);
					//setParts(resp?.cycleCountDetails)
				}
					, (error: any) => {
						console.log("error =>", error);
						toast.error(error);
					});
				/* 
				cycl
				
				
				
				setParts(viewData?.cycleCountDetails) */
			}
		}

	}, [viewData, facilityoption]);

	useEffect(() => {
		getfacilitylist();
	}, []);


	const addScanCode = (code: string) => {
		spearPartsAPI.getSpearPartsList(
			{
				pageSize: 20,
				pageNumber: 1,
				searchParam: code,
			},
			(data: any) => {
				if (data?.sparePartsList?.length > 0) {
					let partOption = {
						label: data?.sparePartsList[0].sparePartsName + ` (${data?.sparePartsList[0].partsCode})`,
						value: data?.sparePartsList[0].partsID,
						partDetails: data?.sparePartsList[0],
					};

					cycleCountAPI.GetStockCount(
						{
							partID: partOption.value,
							facilityID: facilityWatch?.value
						},
						(resp: any) => {
							let alreadyAdded = false;

							setParts(parts.map((part: any) => {
								if (part.partDetails?.partsCode == partOption.partDetails?.partsCode) {
									alreadyAdded = true
									return { ...part, qty: part.qty + 1 }
								} else {
									return part
								}
							}))
							if (!alreadyAdded) {
								setParts([
									...parts,
									{
										...partOption,
										currentStock: resp?.currentStock || 0,
										qty: 1
									},
								]);
							}
						},
						(error: any) => {
							setParts([...parts, { ...partOption, currentStock: 0 }]);
						}
					);
				} else {
					toast.error("No spare part found")
				}
			},
			(error: any) => {
				toast.error("No spare part found")
			}
		);
	}
	const onBulkExportCsv = async () => {
		const payload: any = { cycleCountIDs: viewData.inventoryCycleCountID };
		ExportXls(payload);
	};
	const onBulkExportPdf = async () => {
		const payload: any = { cycleCountIDs: viewData.inventoryCycleCountID };
		ExportPdf(payload);
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)} ref={_ref} >
			<div className="pt-4">
				<div className="bg-green-50 py-2 px-3">
					<h6 className="text-[0.813rem] font-semibold">Cycle Count Ref No</h6>
					<p className="text-[0.813rem] font-normal mt-2">{cycleCountCode}</p>
				</div>
				<div className="grid grid-cols-2 gap-2">
					<div className='mt-2'>
						<Label text='Facility' required={false} />
						<p className='text-[0.85rem] italic font-normal mt-1'>{viewData?.facilityName}</p>
					</div>
					<div className='mt-2'>
						<Label text='Sub Facility' required={false} />
						<p className='text-[0.85rem] italic font-normal mt-1'>{viewData?.subFacilityName}</p>
					</div>

				</div>
			</div>

			<div className='mt-2'>
				<Label text='Date' required={false} />
				<p className='text-[0.85rem] italic font-normal mt-1'>{moment(viewData?.addedDate).format(DATE_FORMAT)}</p>
			</div>
			<div className='mt-2'>
				<Label text='Operator Name' required={false} />
				<p className='text-[0.85rem] italic font-normal mt-1'>{viewData?.operatorName}</p>
			</div>


			<div className="flex justify-end">
				<Dropdown>
					<Dropdown.Button>
						<Button theme='secondary'>Export</Button>
					</Dropdown.Button>
					<Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
						<Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
						<Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>
					</Dropdown.Content>
				</Dropdown>
			</div>
			{partstatus && (
				<>
					<div className="rounded-md border border-gray-300 mt-4 max-h-[450px] overflow-y-auto overflow-x-hidden">
						{/* Sticky header */}
						<div className="grid grid-cols-[repeat(24,minmax(0,1fr))] gap-1 bg-gray-100 sticky top-0 z-10">
							<div className="col-span-5 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Code
								</label>
							</div>
							<div className="col-span-4 px-2 leading-10">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Part Name
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10 text-center">
								<label className="text-[0.75rem] font-medium text-slate-600">
									System Qty
								</label>
							</div>
							<div className="col-span-3 px-2 leading-10 text-center">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Counted Qty
								</label>
							</div>
							<div className="col-span-4 px-2 leading-10 text-right">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Avg Unit Cost
								</label>
							</div>
							<div className="col-span-5 px-2 leading-10 text-right">
								<label className="text-[0.75rem] font-medium text-slate-600">
									Adj. Cost
								</label>
							</div>
						</div>

						{/* Scrollable rows */}
						{parts.map((part: any, index: any) => {
							const signed = part?.signedAdjustmentCost ?? 0;
							return (
								<div
									className="grid grid-cols-[repeat(24,minmax(0,1fr))] gap-1 text-slate-800 border-t border-gray-100"
									key={index}
								>
									<div className="col-span-5 px-2 leading-10 flex items-center">
										<span className="text-[0.75rem] font-normal">{part?.partDetails?.partsCode}</span>
									</div>
									<div className="col-span-4 px-2 leading-10 flex items-center">
										<label className="text-[0.75rem] leading-none font-normal whitespace-nowrap truncate" title={part?.partDetails?.sparePartsName}>
											{part?.partDetails?.sparePartsName}
										</label>
									</div>
									<div className="col-span-3 px-2 leading-10 text-center">
										<label className="text-[0.75rem] font-normal">
											{part?.currentStock}
										</label>
									</div>
									<div className="col-span-3 px-2 leading-10 text-center">
										<label className="text-[0.75rem] font-normal">
											{part?.qty}
										</label>
									</div>
									<div className="col-span-4 px-2 leading-10 text-right">
										<label className="text-[0.75rem] font-normal">
											<Currency currency="USD" value={Number(part?.avgUnitCost ?? 0).toFixed(2)} />
										</label>
									</div>
									<div className="col-span-5 px-2 leading-10 text-right">
										<label className={`text-[0.75rem] font-semibold ${signed > 0 ? 'text-green-600' : signed < 0 ? 'text-red-600' : 'text-slate-800'}`}>
											<Currency currency="USD" value={(signed).toFixed(2)} />
										</label>
									</div>
								</div>
							);
						})}

						{/* Total row — sticky at bottom */}
						<div className="flex items-center justify-between gap-1 bg-gray-100 border-t-2 border-gray-300 sticky bottom-0 px-2">
							<label className="text-[0.75rem] font-semibold text-slate-700 leading-10">
								Total Adjustment Cost
							</label>
							<label className="text-[0.75rem] font-semibold text-slate-800 leading-10 whitespace-nowrap">
								<Currency currency="USD" value={parts.reduce((sum: number, part: any) => sum + (part?.signedAdjustmentCost || 0), 0).toFixed(2)} />
							</label>
						</div>
					</div>
				</>
			)}

			<div className='mt-2'>
				<Label text='Note' required={false} />
				<p className='text-[0.85rem] italic font-normal mt-1'>{viewData?.cycleCountNotes}</p>
			</div>

			<div className="flex justify-end gap-2">

				<Button
					theme="secondary"
					onClick={() => {
						onCancel();
						formReset();
					}}
				>
					Cancel
				</Button>
			</div>
		</form>
	);
};

export default ViewCycleCount;
